import React, { useState } from 'react';
import { connect } from 'react-redux';
import { LOADING } from 'store';
import { Row, Col, Button, Form, Table, Modal, Spinner } from 'react-bootstrap';
import Dialog from 'react-bootstrap-dialog';
import { useTranslation } from 'react-i18next';
import Currency, { currencyReverse, CurrencyPlainText } from 'helpers/Currency';
import { api } from 'services';
import { toast } from 'react-toastify';

const EventsFormExpectedItems = ({
  eventId,
  expectedItems,
  setExpectedItems,
  loading,
}) => {

  const [showModal, setShowModal] = useState(false);

  const [id, setId] = useState('');
  const [name, setName] = useState('');
  const [value, setValue] = useState('');
  const [isLoad, setLoad] = useState(false);

  const { t } = useTranslation();
  let dialog;
  
  const getTotal = event_expense_descriptions => {
    const total = event_expense_descriptions.map(({ value }) => value)
      .reduce((prev, curr) => prev + curr)
    
    return total
  }
  
  const handleHideModal = () => {
    setShowModal(false);
    setId('');
    setName('');
    setValue('');
  };

  const handleEdit = (k) => {
    const data = [...expectedItems][k];

    setId(data.id);
    setName(data.name);
    setValue(data.expected_value);

    setShowModal(true);
  };

  const handleSave = () => {
    loading(true);
    setLoad(true);
    const formData = new FormData();

    if (!!id) formData.append('_method', 'PUT');

    formData.append('event_id', eventId);
    formData.append('name', name);
    formData.append('expected_value', currencyReverse(value));

    api
      .post(!id ? 'event-items' : `event-items/${id}`, formData, {
        headers: {
          'X-Success-Message': `Item ${!id ? 'adicionado' : 'Atualizado'} com sucesso`,
          'X-Show-Alert': true
        }
      })
      .then(() => {
        handleHideModal();
        refreshExpectedItems();
      })
      .finally(() => loading(false) && setLoad(false))
      .catch((error) => {
        loading(false) && setLoad(false);
      });
  };

  const refreshExpectedItems = async () => {
    await api
      .get(`event-items/list-by-event/${eventId}`)
      .then(({ data }) => setExpectedItems(data));

    loading(false);
  };

  const deleteItem = (id) => {
    Dialog.setOptions({
      defaultOkLabel: t('label:yes'),
      defaultCancelLabel: t('label:no'),
      primaryClassName: 'btn-success',
      defaultButtonClassName: 'btn-danger',
    });

    dialog.show({
      title: t('title:expected expense delete'),
      body: t('phrase:are you sure?'),
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          loading(true);
          api.delete(`event-items/${id}`, {
            headers: {
              'X-Success-Message': 'Item removido com sucesso!',
              'X-Show-Alert': true
            }
          }).then(() => {
            loading(false);
            refreshExpectedItems();            
          });
        }),
      ],
      bgSize: 'small',
    });
  };

  return (
    <>
      <Modal show={showModal} onHide={handleHideModal}>
        <Modal.Body>
          <Form.Group>
            <Form.Label>{t('label:expense name')}</Form.Label>
            <Form.Control
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>{t('label:expected expense value')}</Form.Label>
            <Currency
              value={value}
              onChange={(e) => setValue(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button size="sm" variant="danger" onClick={handleHideModal}>
            {t('label:cancel')}
          </Button>
          {isLoad ? (
            <Row className="float-right text-right">
              <Spinner animation="border" style={{ color: '#e05c17' }} />
              <h6 className="m-2">Salvando...</h6>
            </Row>
          ) : (
            <Button size="sm" className="login-btn mr-1" variant="primary-login" onClick={handleSave}>
              {t('label:save')}
            </Button>
          )}
        </Modal.Footer>
      </Modal>
      <Dialog
        ref={(component) => {
          dialog = component;
        }}
      />
      <Row>
        <Col>
          <h4>{t('title:expected expenses at the event')}</h4>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col>
          <Button size="sm" className="login-btn mr-1" variant="primary-login" onClick={() => setShowModal(true)}>
            <i className="fas fa-plus"></i> {t('label:add new')}
          </Button>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <Table bordered hover responsive>
            <thead>
              <tr>
                <th className="text-center align-middle">{t('label:name')}</th>
                <th className="text-center align-middle">
                  {t('label:expected amount')}
                </th>
                <th className="text-center align-middle">
                  {t('label:real value')}
                </th>
                <th className="text-center align-middle">
                  {t('label:actions')}
                </th>
              </tr>
            </thead>
            <tbody>
              {expectedItems.map((expectedItem, k) => (
                <tr key={k}>
                  <td className="text-center align-middle">
                    {expectedItem.name}
                  </td>
                  <td className="text-center align-middle">
                    <CurrencyPlainText value={expectedItem.expected_value} />
                  </td>
                  <td className="text-center align-middle">
                    {expectedItem.event_expense_description.length > 0 ? (
                      <CurrencyPlainText
                        value={getTotal(expectedItem.event_expense_description)}
                      />
                    ) : (
                      '--'
                    )}
                  </td>
                  <td className="text-center align-middle">
                    <Button
                      size="sm"
                      variant="light"
                      onClick={() => handleEdit(k)}
                    >
                      <i className="fas fa-pen" />
                    </Button>
                    <Button
                      size="sm"
                      disabled={!!expectedItem.event_expense_description}
                      className="ml-1"
                      variant="danger"
                      onClick={() => deleteItem(expectedItem.id)}
                    >
                      <i className="fas fa-times" />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Col>
      </Row>
    </>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  loading: (payload) => dispatch({ type: LOADING, payload }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EventsFormExpectedItems);
